import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import Inputs from "../../components/inputs/Inputs";
import MyDialog from "../../components/dialog/Dialog";
import MySpinner from "../../components/Spinner/spinner";
import { useDispatch, useSelector } from "react-redux";
import { customerSchema, disposeSchema, hasAccess, orderSchema } from "../../common/validators";
import validate from "validate.js";
import { getItems } from "../../app/itemsSlice";
import moment from "moment";
import { PDFDownloadLink, PDFViewer, } from "@react-pdf/renderer";
import { CircularProgress } from "@material-ui/core";
import { fetchPurchaseOrders } from "../../app/purchaseOrdersSlice";
import AppAutoComplete from "../../common/appautocomplete";
import { fetchVendors } from "../../app/vendorsSlice";

const tableHead = [
    { label: "Receive date", name: "deliver_date" },
    { label: "PO number", name: "po_number" },
    { label: "Item", name: "item_name" },
    { label: "Supplier Name", name: "vendor_name" },
    { label: "Supplier Email", name: "vendor_email" },
    { label: "PO Status", name: "status" },
    { label: "Quantity", name: "quantity" },
    { label: "Price Per", name: "price_per" },
    { label: "Amount", name: "amount" },
    "action",
];

const PurchaseOrders = () => {



    const dispatch = useDispatch();

    const { error, status, list } = useSelector(
        ({ purchaseOrders }) => purchaseOrders.get
    );

    const { error: itemsError, status : itemsStatus, list: itemsList } = useSelector(
        ({ items }) => items.get
    );

    const { error: vendorsError, status : vendorsStatus, list: vendorsList } = useSelector(
        ({ vendors }) => vendors.get
    );

    const [itemDataList, setItemDataList] = useState([]);
    let [itemsCartList, setItemsCartList] = useState([]);
    const [errors, setErrors] = useState([]);
    const [formValues, setFormValues] = useState({"deliver_date": new Date(),"quantity": 1});
    let [openForm, setOpenForm] = useState(false);
    let [openPreviewDetails, setOpenPreviewDetails] = useState(false);

    let listItems = [
        {item_code: 'SP001', item_description: 'Maji Ltr 0.5', counts: 3000, amount: 1000},
        {item_code: 'SP002', item_description: 'Maji Ltr 12', counts: 2000, amount: 1000},
        {item_code: 'SP003', item_description: 'Cocacola', counts: 1000, amount: 3000},
    ]
    

    useEffect(() => {
        setItemsCartList([])
        dispatch(fetchPurchaseOrders())
    }, [dispatch])

    useEffect(() => {
        if(openForm === true){
            dispatch(getItems())
            dispatch(fetchVendors())
        }
    }, [openForm])


    useEffect(() => {
        if (status === "loading") {

        } else if (status === "idle") {
            let newList = [];
            //newList = list;
            for (let index = 0; index < list.length; index++) {
                let indObject = list[index];
                indObject = {
                    ...indObject,
                    'deliver_date': moment(list[index]['deliver_date']).format("YYYY-MM-DD"),
                    'amount': Number(list[index]['amount']).toLocaleString(),
                    'quantity': Number(list[index]['quantity']).toLocaleString(),
                    'price_per': Number(list[index]['price_per']).toLocaleString(),
                }
                newList.push(indObject)
            }
            setItemDataList(newList);
        }

    }, [status, list]);

    const isAddAccess = () => {
        return hasAccess('orders', 'add');
    }

    const handleRequestClose = () => {
        setErrors([])
        setFormValues({});
        setOpenForm(false);
        setOpenPreviewDetails(false);
    }

    const handleChangeLov = (event) => {    
        //alert(JSON.stringify(event.target))

        

        setFormValues({
          ...formValues,
          [event.target.name]:
            event.target.type === "checkbox"
              ? event.target.checked
              : event.target.value,
        });
      };

    const AddToCart = () => {
        // for (let index = 0; index < itemsList.length; index++){
        //     if(event.target.value === itemsList[index]['id']){
        //         setFormValues({
        //             ...formValues,
        //             item_description: itemsList[index]['item_description']
        //         })
        //     }            
        // }

        

        let myList = itemsCartList;
        let myItem = {
            counts: formValues?.quantity,
            item_id: formValues?.item_id,
            item_description: formValues?.item_description,
            amount: formValues?.quantity * formValues?.unit_price,
            unit_price:  formValues?.unit_price,
            deliver_date: formValues?.deliver_date,
        };
        for (let index = 0; index < itemsList.length; index++){
            if(formValues?.item_id === itemsList[index]['id']){
                myItem = {
                    ...myItem,
                    item_description: itemsList[index]['item_description']
                }
            }            
        }
        myList.push(myItem)

        setItemsCartList(myList)
        
        return true


    }

      const previewDetails = () => {
        return (
          <>
          <div className="row">
            <div className="col-12" style={{paddingBottom:'20px'}}>
                Stanley Mtonyole <br/>
                Physical Address <br/>
                Contacts 
            </div>

            <div className="col-6">
                Customer Name:
            </div>
            <div className="col-6">
                Purchase Order Date:
            </div>
            <div className="col-6">
                Supplier Name:
            </div>
            <div className="col-6">
                Expected Receiving Date:
            </div>
            <div className="col-6" style={{marginTop:'20px'}}>
                <h2>Purchase Order Total</h2>
            </div>
            <div className="col-6" style={{marginTop:'20px', textAlign: 'right', fontSize:'30px'}}>
                9,000,000
            </div>
            <div className="col-12" style={{marginTop:'20px'}}>
            <table>
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Description</th>
                  <th style={{ textAlign: 'right' }}>Qty</th>
                  <th style={{ textAlign: 'right' }}>Unit Price</th>
                  <th style={{ textAlign: 'right' }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {listItems.map((item, index) => (
                  <tr key={item}>
                    <td>{index + 1}</td>
                    <td>{item.item_description}</td>
                    <td style={{ textAlign: 'right' }}>{Number(item.counts).toLocaleString()}</td>
                    <td style={{ textAlign: 'right' }}>{Number(item.amount).toLocaleString()}</td>
                    <td style={{ textAlign: 'right' }}>{item.amount > 0 ? Number(item.amount * item.counts).toLocaleString() : 0}</td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            <div className="col-12" style={{marginTop:'20px', textAlign: 'right'}}>
                <small>Powered by: www.careconnect.com</small>
            </div>
          </div>
          </>
        )}

    const formOpen = () => {
        return (
          <>
            <div className="row">
            <div className="col-sm-12 col-md-4 col-3">
              <AppAutoComplete
                label="Supplier"
                itemStateValue="vendor_id"
                values={formValues}
                setValues={setFormValues}
                options={vendorsList ?? []}
                optionName={['name']}
                optionId="id"
                handleChange={handleChangeLov}
                page={"pos"}
              />
              </div>

              <div className="col-sm-12 col-md-4 col-3">
              <AppAutoComplete
                label="Items"
                itemStateValue="item_id"
                values={formValues}
                setValues={setFormValues}
                options={itemsList}
                optionName={['item_description']}
                optionId="id"
                handleChange={handleChangeLov}
                page={"pos"}
              />
              </div>
              <div className="col-sm-12 col-md-4 col-2">
                <Inputs
                  name="quantity"
                  size="small"
                  label="Quantity"
                  value={formValues.quantity}
                  inputType="number"
                  onChange={handleChangeLov}
                  error={errors["quantity"] ? true : false}
                  helperText={errors["quantity"] ? errors.quantity[0] : null}
                />
              </div>
              <div className="col-sm-12 col-md-4 col-2">
                <Inputs
                  name="unit_price"
                  size="small"
                  label="Unit Price"
                  value={formValues.unit_price}
                  inputType="number"
                  onChange={handleChangeLov}
                  error={errors["unit_price"] ? true : false}
                  helperText={errors["unit_price"] ? errors.unit_price[0] : null}
                />
              </div>
              <div className="col-sm-12 col-md-4 col-2">
                <Inputs
                  name="deliver_date"
                  size="small"
                  label="Receive Date"
                  value={formValues.deliver_date}
                  inputType="date"
                  onChange={(e) => {handleChangeLov({ target: { name: "deliver_date", value: e } })}}
                  error={errors["deliver_date"] ? true : false}
                  helperText={errors["deliver_date"] ? errors.deliver_date[0] : null}
                />
              </div>
              <div className="col-sm-12 col-md-4 col-2">
                <Inputs
                    color="success"
                    className={`bx-burst-hover`}
                    size="small"
                    inputType="button"
                    type="submit"
                    text={"Add to List"}
                    onClick={(e) => {e.preventDefault(); AddToCart()}}
                    propBackgroundColor={"#367588"}
                />
              </div>

              <div className="col-12" style={{marginTop:'20px'}}>
            <table>
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Description</th>
                  <th style={{ textAlign: 'right' }}>Qty</th>
                  <th style={{ textAlign: 'right' }}>Unit Price</th>
                  <th style={{ textAlign: 'right' }}>Amount</th>
                  <th style={{ textAlign: 'right' }}>Deliver Date</th>
                </tr>
              </thead>
              <tbody>
                {itemsCartList.length > 0 &&  itemsCartList.map((item, index) => (
                  <tr key={item}>
                    <td>{index + 1}</td>
                    <td>{item?.item_description}</td>
                    <td style={{ textAlign: 'right' }}>{Number(item?.counts).toLocaleString()}</td>
                    <td style={{ textAlign: 'right' }}>{item.unit_price > 0 ? Number(item.unit_price).toLocaleString() : 0}</td>
                    <td style={{ textAlign: 'right' }}>{item.amount > 0 ? Number(item.amount).toLocaleString() : 0}</td>
                    <td style={{ textAlign: 'right' }}>{moment(formValues?.deliver_date).format('YYYY-MM-DD')}</td>                    
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
    
            </div>
          </>
        );
      };

    return (
        <div>
            <div className="ez-page-action">
                {/* <h2 className="page-header">Data</h2> */}
                &nbsp;
                <div className="row">
                    <div className="col-4" style={{ alignContent: "right" }}>
                        {isAddAccess &&
                            <Inputs
                                color="success"
                                className={`bx-burst-hover`}
                                size="small"
                                inputType="button"
                                type="submit"
                                text={"New Purchase Order"}
                                onClick={() => setOpenForm(true)}
                                propBackgroundColor={"#367588"}
                            />
                        }
                        &nbsp;
                        {isAddAccess &&
                            <Inputs
                                color="success"
                                className={`bx-burst-hover`}
                                size="small"
                                inputType="button"
                                type="submit"
                                text={"New Supplier"}
                                // onClick={() => setOpenForm(true)}
                                propBackgroundColor={"#800000"}
                            />
                        }
                    </div>
                    <br />
                    <br />
                    <div className="col-12">
                        <div className="card" style={{ backgroundColor: "#e0e0e0" }}>
                            <div className="card-body">
                                {list.length > 0 ? (
                                    <Table
                                        columns={tableHead}
                                        data={itemDataList}
                                        actions={[
                                            {
                                                action: "Details",
                                                // renderCheck: isViewAccess,
                                                onClick: (item) => {
                                                    //viewItem(item);
                                                    setOpenPreviewDetails(true)
                                                },
                                            },

                                        ]}
                                        downloadFileName={"Customer Orders"}
                                    />
                                ) : (
                                    <MySpinner size={35} color="#367588" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <MyDialog
                title={"New Purchase Order"}
                width="lg"
                onClose={handleRequestClose}
                open={openForm}
                text={"Save"}
                content={() => formOpen()}
                // submit={(e) => handleSubmit(e)}
                // hideSaveButton={hideSaveButton}
                propBackgroundColor="#367588"
            />

            <MyDialog
                title={""}
                width="md"
                onClose={handleRequestClose}
                open={openPreviewDetails}
                text={"Download File"}
                content={() => previewDetails()}
                // submit={(e) => handleSubmit(e)}
                hideSaveButton={!openPreviewDetails}
                propBackgroundColor="#367588"
            />
        </div>
    )

}

export default PurchaseOrders;